/* eslint-disable no-param-reassign, @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { useFormState } from 'react-hook-form';

import useCallbackPrompt from 'src/hooks/useCallbackPrompt';

interface FormConfirmationWarningProps {
}

const FormConfirmationWarning = function FormConfirmationWarning(
  props: FormConfirmationWarningProps,
) {
  const { isDirty } = useFormState();
  useCallbackPrompt('You are attempting to open an other page, all the data added will be lost.', isDirty);

  return null;
};

FormConfirmationWarning.defaultProps = {

};

FormConfirmationWarning.propTypes = {

};

export default FormConfirmationWarning;
